import images from '../../Constants/images';
import "./Contact.css";
import Info from './Info';

const Contact = () => {
  return (
    <section className='contact section-p-top bg-black' id = "contact">
        <div className='container'>
            <div className='contact-content grid text-center'>
                <div className='contact-left'>
                    <div className='section-t'>
                        <h3>Let's Talk?</h3> 
                        <p className='text'>Have a project in mind or questions? We're here to help! Fill out the form below, and let's start a conversation.</p>
                    </div>

                    {/* Contact form temporarily hidden 
                    <Formik
                        initialValues={{ name: "", email: '', address: '' }}
                        validate={values => {
                            const errors = {};

                            if(!values.name){
                                errors.name = "Name is required";
                            } else if(!/^[A-Za-z\s]*$/.test(values.name)){
                                errors.name = "Invalid name format";
                            }

                            if (!values.email) {
                                errors.email = 'Email is required';
                            } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                            ) {
                                errors.email = 'Invalid email address';
                            }

                            if(!values.address){
                                errors.address = "Address is required";
                            }
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            setTimeout(() => {
                            alert(JSON.stringify(values, null, 2));
                            setSubmitting(false);
                            }, 400);
                        }}
                        >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <div className='form-elem'>
                                    <input type = "text" name = "name" onChange = {handleChange} onBlur = {handleBlur} value = {values.name} className = "form-control" placeholder='Name'/>
                                    <span className='form-control-text'>{errors.name && touched.name && errors.name}</span>
                                </div>

                                <div className='form-elem'>
                                    <input type = "email" name = "email" onChange = {handleChange} onBlur = {handleBlur} value = {values.email} className = "form-control" placeholder='Email'/>
                                    <span className='form-control-text'>{errors.email && touched.email && errors.email}</span>
                                </div>

                                <div className='form-elem'>
                                    <input type = "text" name = "address" onChange = {handleChange} onBlur = {handleBlur} value = {values.address} className = "form-control" placeholder='Address'/>
                                    <span className='form-control-text'>{errors.address && touched.address && errors.address}</span>
                                </div>

                                <div className='flex flex-start'>
                                    <button type = "submit" disabled = {isSubmitting} className = "submit-btn">contact us</button>
                                </div>
                            </form>
                        )}
                        </Formik>
                        */}

                        <div className='coming-soon-message' style={{marginTop: "2rem", padding: "1.5rem", background: "rgba(255,255,255,0.05)", borderRadius: "8px", border: "1px dashed rgba(255,255,255,0.2)"}}>
                            <h4 style={{color: "#e16045", marginBottom: "0.5rem", fontSize: "1.3rem"}}>Coming Soon!</h4>
                            <p style={{color: "#ccc", fontSize: "0.95rem"}}>Our contact form is currently undergoing maintenance. Please reach out to us directly via email in the meantime.</p>
                        </div>
                </div>

                <div className='contact-right'>
                    <img src = {images.form_main_img} alt = "" />
                </div>
            </div>
        </div>

        {/* <Map /> */}
        <Info />
    </section>
  )
}

export default Contact